<template>
  <b-card
    :title="header"
    class="mt-5 mx-auto"
    :style="isMobile ? '' : 'width: 550px'"
  >
    <b-form onkeydown="return event.key != 'Enter'">
      <p class="pb-2 grey--text">{{ subheader }}</p>

      <b-form-group
        id="input-group-password"
        class="col-12"
        v-if="currentStep === 1"
      >
        <b-form-input
          id="input-password"
          v-model="form.password"
          type="password"
          required
          autofocus
          class="input-effect"
          :class="form.password ? 'has-content' : ''"
          @keyup.enter="nextStep"
        ></b-form-input>
        <label>Password</label>

        <div class="input-error" v-if="form.$getError('password')">
          {{ form.$getError('password')[0] }}
        </div>
      </b-form-group>

      <b-form-group id="input-group-new-password" class="col-12" v-else>
        <b-form-input
          id="input-new-password"
          v-model="form.new_password"
          type="password"
          required
          class="input-effect"
          :class="form.new_password ? 'has-content' : ''"
          @keyup.enter="nextStep"
        ></b-form-input>
        <label>New Password</label>

        <div class="input-error" v-if="form.$getError('new_password')">
          {{ form.$getError('new_password')[0] }}
        </div>
      </b-form-group>

      <div class="input-error custom-error" v-if="form.$errorMessage">
        {{ form.$errorMessage }}
      </div>

      <hr class="modal-divider mt-5" />

      <div class="text-right mt-2 mb-1">
        <b-button
          class="btn-outlined bg-white text-dark mr-2"
          variant="outline-secondary"
          :to="{ name: 'user.settings-page', params: { tab: 3 } }"
          >Cancel</b-button
        >
        <b-button variant="primary" :disabled="loading" @click="nextStep">
          <b-spinner small v-if="loading"></b-spinner>&nbsp;Continue
        </b-button>
      </div>
    </b-form>
  </b-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Form from '@/utils/form'

export default {
  computed: {
    ...mapState({
      verificationToken: state => state.auth.verificationToken
    })
  },

  data() {
    return {
      loading: false,
      header: 'Verify Password',
      subheader: 'Enter your current password to change your password',
      currentStep: 1,
      form: new Form({
        password: null,
        new_password: null
      })
    }
  },

  methods: {
    ...mapActions({
      getVerificationToken: 'auth/getVerificationToken',
      changePassword: 'auth/changePassword'
    }),

    nextStep() {
      if (this.currentStep === 1) {
        this.generateToken()
      }
      if (this.currentStep === 2) {
        this.updatePassword()
      }
    },

    async generateToken() {
      this.loading = true
      await this.getVerificationToken({
        password: this.form.password
      })
        .then(() => {
          this.currentStep++
          this.header = 'New Password'
          this.subheader = 'Enter new password'
          this.form.$clearErrors()
        })
        .catch(error => {
          this.form.$handleError(error)
        })
      this.loading = false
    },

    async updatePassword() {
      this.loading = true
      await this.changePassword({
        old_password: this.form.password,
        new_password: this.form.new_password,
        new_password_confirmation: this.form.new_password
      })
        .then(() => {
          this.$router.replace({
            name: 'user.settings-page',
            params: { tab: 3 }
          })
        })
        .catch(error => {
          this.form.$handleError(error)
        })
      this.loading = false
    }
  }
}
</script>

<style scoped>
.btn.btn-outlined {
  padding: 4px 32px;
}
.btn {
  height: 36px;
}
.custom-error {
  margin-top: -1rem;
}
</style>
